// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import AntiguaBarbuda from '../_raw/flag/icon_flag_antigua_barbuda.png';

export default () => <img src={AntiguaBarbuda} alt="AntiguaBarbuda" />;
